import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { getAlphabetFromIndex } from '../../../utils/utils'

export default function ViewOptions({ question,qnumber }) {

    const answer = question.options.map((option, index) => {
        if (option.isCorrect) {
            if (option.explanation) {
                return <Row className="d-flex align-items-baseline mt-2" key={index}>
                    <Col lg={12} className="ans-hint" style={{ lineHeight: '2rem' }}>
                        <small><strong>{`Answer: `}</strong></small>
                        <small>{option.text}</small>

                    </Col>
                    <Col lg={12} className="myquestion-bg mt-2" style={{ lineHeight: '2rem' }}>
                        <small><strong>{`Explanation: `}</strong></small>
                        <small>{option.explanation}</small>
                    </Col>
                </Row>
            } else {
                return <Row className="d-flex align-items-baseline mt-2" key={index}>
                    <Col lg={12} className="ans-hint" key={`answer_${index}`} style={{ lineHeight: '2rem' }}>
                        <small><strong>{`Answer: `}</strong></small>
                        <small>{option.text}</small>
                    </Col>
                </Row>
            }
        }
    })

    return (
        <Row>
            <Col lg={12} className="fw-semibold text-start" style={{ paddingLeft: '1rem', fontSize:'1rem' }}><span className="fw-bold">Q{qnumber}.</span> {question.questionText} ?</Col>
            <Col lg={12} style={{ width: '96%', margin: '0 auto' }}>
                <Row className="d-flex align-items-baseline text-start">
                    {question.options.map((option, index) => {
                        return <Col lg={6} key={index} className="ps-4" style={{display:'flex', alignItems:'baseline'}}>
                            <small style={{fontWeight: '700', float: 'left',whiteSpace: 'nowrap' }}>{`Option ${getAlphabetFromIndex(index)} : `}</small>
                            <small style={{ padding: '10px', display: 'flex' }}>{option.text}</small>
                        </Col>
                    })}
                </Row>
                {answer}
            </Col>

        </Row>
    );
}